import React,{useEffect,useState} from "react";
import {Col, Divider, Row, Slider, Spin,Pagination,ConfigProvider } from 'antd';
import "./ShopSearch.scss";
import HeaderDesktop from "../DesktopComponents/HeaderDesktop/HeaderDesktop";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";
import {useHistory, useLocation} from "react-router";
import {useParams} from "react-router-dom";
import {getShopCategories_api, getShopProducts_api} from "../../Services/apis";
import {numberWithCommas} from "../../Services";
import { DownCircleOutlined, MenuOutlined, AlignCenterOutlined } from '@ant-design/icons';

let minPrice = 0;
let maxPrice = 100000000;
let mainSort = null



function SortMenuComponent({id,cats,currentSubCat,currentRootCat,getProducts,set_total,set_page,set_currentSubCat}) {

    const [open,set_open] = useState(false)

    const toggleList = ()=>{
        set_open(!open);
    }

    const handleSelect = (s)=>{
        set_page(1)
        set_total(1)
        mainSort=s

        let cId = "";

        if(currentRootCat)
            cId = currentRootCat

        if(currentSubCat)
            cId = currentSubCat


        getProducts(id,cId)
    }

    return(
        <div className="shop-options-row-sort" onClick={e=>{
            toggleList()
        }}>
            <div className="shop-options-row-sort-info">
                <span className="shop-options-row-sort-title">مرتب سازی</span>
                <span className="shop-options-row-sort-icon"><AlignCenterOutlined /></span>
            </div>

            {open?<div className="shop-options-row-sort-list">
                    <span className={mainSort==="price"?"shop-options-row-sort-item-active":"shop-options-row-sort-item"}  onClick={e=>handleSelect("price")}>ارزانترین</span>
                    <span className={mainSort==="-price"?"shop-options-row-sort-item-active":"shop-options-row-sort-item"} onClick={e=>handleSelect("-price")}>گرانترین</span>
                    <span className={mainSort==="-created"?"shop-options-row-sort-item-active":"shop-options-row-sort-item"} onClick={e=>handleSelect("-created")}>جدیدترین</span>
            </div>:null}


        </div>
    )
}



function CatMenuComponent({id,cats,currentSubCat,currentRootCat,getProducts,set_total,set_page,set_currentSubCat}) {

    const [open,set_open] = useState(false)

    const toggleList = ()=>{
        set_open(!open);
    }

    return(
        <div className="shop-options-row-sort" onClick={e=>{
            toggleList()
        }}>
            <div className="shop-options-row-sort-info">
                <span className="shop-options-row-sort-title">دسته بندی</span>
                <span className="shop-options-row-sort-icon"><MenuOutlined /></span>
            </div>

            {open?<div className="shop-options-row-sort-list">
                <div
                    className={!currentSubCat?"shop-cats-item-active":"shop-cats-item"}
                    onClick={e=>{
                        set_currentSubCat(null)
                        set_page(1)
                        set_total(1)
                        getProducts(id,currentRootCat)
                        // getCats(id,c.uid)
                    }}
                >
                    <span>همه</span>
                </div>

                {cats?.map(c=>{
                    return(
                        <div
                            className={currentSubCat===c.uid?"shop-cats-item-active":"shop-cats-item"}
                            onClick={e=>{
                                set_currentSubCat(c.uid)
                                getProducts(id,c.uid)
                                // getCats(id,c.uid)
                            }}
                        >
                            <span>{c.name}</span>
                        </div>
                    )
                })}

            </div>:null}


        </div>
    )
}

const style = {
    background: '#0092ff',
    // padding: '8px 0',
};
function ShopSearch (){
    const location = useLocation()
    const [products,set_products] = useState([])
    const [spin,set_spin] = useState(false)
    const [catSpin,set_catSpin] = useState(false)
    const [currentRootCat,set_currentRootCat] = useState(null)
    const [currentSubCat,set_currentSubCat] = useState(null)
    const [cats,set_cats] = useState([])
    const [rootCats,set_rootCats] = useState([])
    const { id,catId } = useParams();
    const history = useHistory();


    //paginate
    const [page,set_page] = useState(1)
    const [total,set_total] = useState(1)

    const changePage = (e)=>{
        console.log(e)
        set_page(e)
        if(currentSubCat)
        getPaginateProducts(id,currentSubCat,e)
        else
        getPaginateProducts(id,currentRootCat,e)
    }

    useEffect(()=>{
        window.scrollTo({left: 0, top: 0});
        getProducts(id,catId)
        getCats(id,catId)

        // if(location && location.state && location.state.cats && location.state.cats.length > 0){
        if(location?.state?.cats?.length > 0){
            set_rootCats(location.state.cats)
            set_currentRootCat(catId)
        }
    },[])

    const getPaginateProducts = async (i,c,p)=>{
        set_spin(true)
        try{
            const res = await getShopProducts_api(i,c,p,minPrice,maxPrice,mainSort)
            set_spin(false)
            set_products(res.data.results)
            set_total(res.data.count)
        }catch(e){
            set_spin(false)
            console.log(e)
        }
    }


    const getProducts = async (i,c)=>{
        console.log("vvvvvvvvvvvvv",i,c)
        set_spin(true)
        try{
            const res = await getShopProducts_api(i,c,1,minPrice,maxPrice,mainSort)
            set_spin(false)
            set_products(res.data.results)
            set_total(res.data.count)
        }catch(e){
            set_spin(false)
            console.log(e)
        }
    }

    const getCats = async (i,c)=>{
        set_catSpin(true)
        try{
            set_currentRootCat(c)
            const res = await getShopCategories_api(i,c)
            set_catSpin(false)
            set_cats(res.data)
        }catch(e){
            set_catSpin(false)
            console.log(e)
        }
    }

    const defaultImage = "https://test-loyalty-minio.darkube.app/loyalty-media/product/product/images/9a22de82-a7d7-403b-8b14-a2c60e04cda0.jpg"

    const [min, set_min] = useState(0);
    const [max, set_max] = useState(100000000);

    const onChange = (value) => {
        // console.log('onChange: ', value);
    };
    const onAfterChange = (value) => {
        set_min(value[0])
        set_max(value[1])
        minPrice = value[0]
        maxPrice = value[1]

        //call api
        set_page(1)
        set_total(1)


        let cId = "";

        if(currentRootCat)
            cId = currentRootCat

        if(currentSubCat)
            cId = currentSubCat

        getProducts(id,cId)
    };



    return(
        <div>
            <div className="home-fixed-container">
                <HeaderDesktop mId={id} active="shop"/>
            </div>


            <div className="home-responsive-container">
                <div className="home-responsive-body">

                    <div className="shop-container">

                        <div className="shop-left-sec">
                            <div className="shop-root-cat">
                                {rootCats?.map(c=>{
                                    return(
                                        <div
                                            className={currentRootCat===c.uid?"shop-root-cat-item-active":"shop-root-cat-item"}
                                            onClick={e=>{
                                                set_currentSubCat(null)
                                                set_page(1)
                                                set_total(1)
                                                getProducts(id,c.uid)
                                                getCats(id,c.uid)
                                            }}
                                        >
                                            <span>{c.name.length>10?"..."+c.name.substr(0,25):c.name}</span>
                                        </div>
                                    )
                                })}
                            </div>


                            <div className="shop-banner">
                                <img
                                    src="https://test-loyalty-minio.darkube.app/loyalty-media/page/section_item/desktop_images/%D8%A8%D9%87%D8%AF%D8%A7%D8%B4%D8%AA%DB%8C_1_qfNBfTW.png"
                                    alt=""/>
                            </div>


                            <div className="shop-options-row">

                                <SortMenuComponent
                                    id={id}
                                    set_total={set_total}
                                    currentSubCat={currentSubCat}
                                    cats={cats}
                                    currentRootCat={currentRootCat}
                                    getProducts={getProducts}
                                    set_currentSubCat={set_currentSubCat}
                                    set_page={set_page}
                                />

                                {/*<div className="shop-options-row-sort">*/}
                                {/*    <div className="shop-options-row-sort-info">*/}
                                {/*        <span className="shop-options-row-sort-title">مرتب سازی</span>*/}
                                {/*        <span className="shop-options-row-sort-icon"><AlignCenterOutlined /></span>*/}
                                {/*    </div>*/}
                                {/*    /!*<div className="shop-options-row-sort-list">*!/*/}
                                {/*    /!*    <span className="shop-options-row-sort-item">ارزانترین</span>*!/*/}
                                {/*    /!*    <span className="shop-options-row-sort-item">گرانترین</span>*!/*/}
                                {/*    /!*</div>*!/*/}
                                {/*</div>*/}

                                <div className="shop-options-row-sort">
                                    <div className="shop-options-row-sort-info">
                                        <span className="shop-options-row-sort-icon"><DownCircleOutlined /></span>
                                        <span className="shop-options-row-sort-title">برند</span>
                                    </div>
                                    {/*<div className="shop-options-row-sort-list">*/}
                                    {/*    <span className="shop-options-row-sort-item">اروال</span>*/}
                                    {/*    <span className="shop-options-row-sort-item">صحت</span>*/}
                                    {/*</div>*/}
                                </div>

                                <div className="shop-options-row-sort price-flex">
                                    <div className="shop-options-row-sort-price">
                                        <div className="shop-options-row-sort-price-labels">
                                            <span className="shop-options-row-sort-price_number">{numberWithCommas(min)}</span>
                                            <span className="shop-options-row-sort-price_title">قیمت (ریال)</span>
                                            <span className="shop-options-row-sort-price_number">{numberWithCommas(max)}</span>
                                        </div>
                                        <div className="shop-filter-item-body">
                                            <Slider
                                                range
                                                min={0}
                                                max={100000000}
                                                step={1000}
                                                defaultValue={[0, 100000000]}
                                                onChange={onChange}
                                                onAfterChange={onAfterChange}
                                            />
                                            {/*<DualSliderDesktop*/}
                                            {/*        range*/}
                                            {/*        min={20000}*/}
                                            {/*        max={1000000000}*/}
                                            {/*        value={typeof inputValue === 'number' ? inputValue : 0}*/}
                                            {/*        step={100}*/}
                                            {/*        onChange={onChangeSlider}*/}

                                            {/*        disabled={false} />*/}
                                        </div>
                                    </div>

                                </div>


                                <CatMenuComponent
                                    id={id}
                                    set_total={set_total}
                                    currentSubCat={currentSubCat}
                                    cats={cats}
                                    currentRootCat={currentRootCat}
                                    getProducts={getProducts}
                                    set_currentSubCat={set_currentSubCat}
                                    set_page={set_page}
                                />

                                {/*<div className="shop-options-row-sort">*/}
                                {/*    <div className="shop-options-row-sort-info">*/}
                                {/*        <span className="shop-options-row-sort-title">دسته بندی</span>*/}
                                {/*        <span className="shop-options-row-sort-icon"><MenuOutlined /></span>*/}
                                {/*    </div>*/}

                                {/*    <div className="shop-options-row-sort-list">*/}
                                {/*        <span className="shop-options-row-sort-item">اروال</span>*/}
                                {/*        <span className="shop-options-row-sort-item">صحت</span>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                            </div>




                            <Spin spinning={spin}>
                                <div className="shop-products">
                                    {products?.map(p=>{
                                        return(
                                            <div className="shop-products-item" onClick={e=>{
                                                history.push(`/online-store-product/${id}/${p.uid}`)
                                            }}>
                                                <img src={p.image?p.image:defaultImage} alt=""/>
                                                <span>{p.name}</span>
                                                <div className="shop-price-sec">
                                                    <span> {numberWithCommas(p.price)} ریال </span>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </Spin>
                            <div className="shop-paginate">
                                <Pagination
                                    onChange={changePage}
                                    current={page} defaultPageSize={10} total={total} showSizeChanger={false} />
                            </div>
                        </div>

                        {/*<div className="shop-right-sec">*/}


                        {/*    <div className="shop-cats">*/}
                        {/*        <div className="shop-cats-title">*/}
                        {/*            <span>مرتب سازی بر اساس</span>*/}
                        {/*        </div>*/}
                        {/*        <select name="" id="">*/}
                        {/*            <option value="">ارزانترین</option>*/}
                        {/*            <option value="">گرانترین</option>*/}
                        {/*            <option value="">محبوبترین</option>*/}
                        {/*        </select>*/}
                        {/*    </div>*/}

                        {/*    <Spin spinning={catSpin}>*/}
                        {/*        <div className="shop-cats">*/}
                        {/*            <div className="shop-cats-title">*/}
                        {/*                <span>دسته بندی ها</span>*/}
                        {/*            </div>*/}
                        {/*            <div*/}
                        {/*                className={!currentSubCat?"shop-cats-item-active":"shop-cats-item"}*/}
                        {/*                onClick={e=>{*/}
                        {/*                    set_currentSubCat(null)*/}
                        {/*                    set_page(1)*/}
                        {/*                    set_total(1)*/}
                        {/*                    getProducts(id,currentRootCat)*/}
                        {/*                    // getCats(id,c.uid)*/}
                        {/*                }}*/}
                        {/*            >*/}
                        {/*                <span>همه</span>*/}
                        {/*            </div>*/}
                        {/*            {cats?.map(c=>{*/}
                        {/*                return(*/}
                        {/*                    <div*/}
                        {/*                         className={currentSubCat===c.uid?"shop-cats-item-active":"shop-cats-item"}*/}
                        {/*                         onClick={e=>{*/}
                        {/*                             set_currentSubCat(c.uid)*/}
                        {/*                             getProducts(id,c.uid)*/}
                        {/*                             // getCats(id,c.uid)*/}
                        {/*                         }}*/}
                        {/*                    >*/}
                        {/*                        <span>{c.name}</span>*/}
                        {/*                    </div>*/}
                        {/*                )*/}
                        {/*            })}*/}
                        {/*        </div>*/}
                        {/*    </Spin>*/}

                        {/*    <hr/>*/}

                        {/*    <div className="shop-filter">*/}
                        {/*        <div className="shop-filter-item">*/}
                        {/*            <span className="shop-filter-item-title">قیمت</span>*/}
                        {/*            <div className="shop-filter-item-body">*/}
                        {/*                <DualSliderDesktop defaultValue={30} tooltip={{ open: true }} />*/}
                        {/*            </div>*/}
                        {/*        </div>*/}

                        {/*        /!*<div className="shop-filter-item">*!/*/}
                        {/*        /!*    <span className="shop-filter-item-title">رنگ</span>*!/*/}
                        {/*        /!*</div>*!/*/}

                        {/*        /!*<div className="shop-filter-item">*!/*/}
                        {/*        /!*    <span className="shop-filter-item-title">برند</span>*!/*/}
                        {/*        /!*</div>*!/*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>

                </div>
            </div>
            <br/><br/>
            <FooterDesktop/>
        </div>
    )

}
export default  ShopSearch
